import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { z } from "zod";

export const useProductAutomationFormSchema = () => {
  const { t } = useTranslation("product");

  const schema = useMemo(
    () =>
      z.object({
        link_endpoint: z
          .string()
          .min(1, t("automationModal.validations.endpointRequired")),
        authentification: z
          .string()
          .min(1, t("automationModal.validations.authenticationRequired")),
        body_fields: z
          .array(
            z.object({
              id: z.number().optional(),
              title: z
                .string()
                .min(1, t("automationModal.validations.titleRequired")),
              key: z
                .string()
                .min(1, t("automationModal.validations.keyRequired"))
            })
          )
          .min(1, t("automationModal.validations.bodyFieldsRequired")),
        response_fields: z
          .array(
            z.object({
              id: z.number().optional(),
              key: z
                .string()
                .min(1, t("automationModal.validations.keyRequired"))
            })
          )
          .min(1, t("automationModal.validations.responseFieldsRequired"))
      }),
    [t]
  );

  return schema;
};

export type ProductAutomationFormSchema = z.infer<
  ReturnType<typeof useProductAutomationFormSchema>
>;
